import {Modal } from 'antd';
import './style.less';


const JoinModel = (props: any) => {
    const {

        handleOk,
        handleCancel,
        isModalVisible,
        qrCode
    } = props;

    return (
        <>

            <Modal

                className="join_model"
                visible={isModalVisible}
                onCancel={handleCancel}
                onOk={handleOk}
                centered={true}
                mask={true}
                maskStyle={{ background: "rgba(0,0,0,0.50)" }}
                width={472}
                footer={null}
                closeIcon = {<div className="join_icon"></div>}
            >
                {/* 二维码 */}
                <div className="qr_code_wrapper">
                    <div className="qr_code_title">{qrCode.qrCodeTitle ?? ""}</div>
                    <div className="qr_code_desc">{qrCode.qrCodeDesc ?? ""}</div>
                    <div className="qr_code_img" style={{background:`url(${qrCode.backImg})`}}></div>
                    <div className="qr_code_steps">{qrCode.stepsOne ?? ""}</div>
                    <div className="qr_code_sub_steps">{qrCode.stepsTwo ?? ""}</div>
                </div>

            </Modal>

        </>
    )
}

export default JoinModel;